<div class="dashboard-content">

  <div class="title">
    <h2>Мои</h2>
    <h1>Путешествия</h1>
  </div>

    <div class="tabs-wrapper blue">
        <div class="title">
            <div class="tab-wrapper-item" [class.active]="activeTab === 1" (click)="changeTab(1)">Активные
            </div>
            <div class="tab-wrapper-item" [class.active]="activeTab === 2" (click)="changeTab(2)">Новые
            </div>
            <div class="tab-wrapper-item" [class.active]="activeTab === 3" (click)="changeTab(3)">Прошедшие
            </div>
            <span class="tab-line"></span>
        </div>
         <div class="tabs-content">
            <app-travels-list [type]="1" *ngIf="activeTab === 1" >  </app-travels-list>
            <app-travels-list [type]="2" *ngIf="activeTab === 2" >  </app-travels-list>
            <app-travels-list [type]="3" *ngIf="activeTab === 3" >  </app-travels-list>
         </div>
    </div>
</div>

